import { TipTopfRecipeResponseType } from "@/utils/rezeptAPI/getFilteredRecipes";
import { RecipeGridModuleType } from "./RecipeGrid";
import { getImageOrFallback } from "@/utils/rezeptAPI/helper";
import { RecipeElementType } from "@/components/RecipeCard/RecipeCard";
import { ImageType } from "@/types/baseTypes";
import { RecipeFiltersType, TipTopfSortType } from "@/components/Grid/Grid";

export type RecipeGridResponseType = {
  posts: Array<RecipeElementType>;
  totalPosts: number;
};

// jscpd:ignore-start
export const fetchRecipes = async (
  getLabel: (key: string, fallback?: string | undefined) => string,
  gridData: RecipeGridModuleType["grid"],
  postsPerPage: number,
  page: number,
  sortType: TipTopfSortType,
  filters: RecipeFiltersType,
  fallbackImage?: ImageType | false,
  produkttyp?: number,
): Promise<RecipeGridResponseType> => {
  const { categories, difficulty_level, posts, type } = gridData;
  let res: Response;
  let result: TipTopfRecipeResponseType | null;

  try {
    switch (type) {
      case "categories":
        res = await fetch(
          `/api/recipes?type=filterCategories&difficulty_level=${difficulty_level}&sort_type=${sortType}&results_per_page=${postsPerPage}&results_page=${page}&kategorie=${categories}`,
        );
        break;
      case "posts":
        res = await fetch(`/api/recipes?type=filterPosts&posts=${posts}`);
        break;
      case "show-all":
        res = await fetch(
          `/api/recipes?type=filterAll&sort_type=${sortType}&results_per_page=${postsPerPage}&results_page=${page}&schwierigkeitsgrad=${filters.difficultyLevel ?? ""}&kategorie=${filters.categories.join(",")}&produkttyp=${produkttyp}`,
        );
        break;
    }

    result = await res.json();
  } catch (err) {
    console.error("Error while filter recipes: ", err);
    result = null;
  }

  const recipes = result?.rezepte_list.map((recipe) => {
    return {
      recipeId: recipe.rezept_id,
      isClickOut: recipe.schwierigkeitsgrad === 0,
      title: recipe.rezept_titel,
      difficultyLevel: {
        level: recipe.schwierigkeitsgrad,
        label: getLabel(`difficulty_level_${recipe.schwierigkeitsgrad}_label`),
      },
      image: getImageOrFallback(recipe, fallbackImage),
    } satisfies RecipeElementType;
  });

  return {
    posts: recipes ?? [],
    totalPosts: result?.rezepte_count ?? 0,
  };
};
// jscpd:ignore-end
